import Keycloak from 'keycloak-js';
import router from './router'; 

const keycloak = new Keycloak({
	url: process.env.VUE_APP_KEYCLOAKURL,
	realm: process.env.VUE_APP_KEYCLOAKREALM,
	clientId: process.env.VUE_APP_KEYCLOAKCLIENT
});

keycloak.debug = true;

//const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const initKeycloak = () => {
	const maxRetries = 3;
	const retryCount = parseInt(localStorage.getItem('kcRetryCount')) || 0;
	return new Promise((resolve, reject) => {
		keycloak.init({
			onLoad: "check-sso",
			silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`, // Required for silent auth
			pkceMethod: "S256",
			checkLoginIframe: false,
			flow: "standard",
		})
		.then((authenticated) => {
			if (authenticated) {
				console.log("User is authenticated");
				localStorage.setItem("kcToken", keycloak.token);
				localStorage.setItem("kcRefreshToken", keycloak.refreshToken);
				localStorage.removeItem("kcRetryCount");
				resolve(keycloak);
			} else {
				console.warn("User is not authenticated");
				localStorage.removeItem("kcToken");
				localStorage.removeItem("kcRefreshToken");
				resolve(keycloak);
			}
		})
		.catch((error) => {
			console.error("Keycloak initialization failed:", error);
			if (retryCount < maxRetries) {
				const nextRetryCount = retryCount + 1;
				localStorage.setItem("kcRetryCount", nextRetryCount);
				console.warn(`Retrying Keycloak initialization (${nextRetryCount}/${maxRetries})...`);
				setTimeout(() => initKeycloak().then(resolve).catch(reject), 1000);
			} else {
				console.error("Max retries reached. Unable to initialize Keycloak.");
				localStorage.removeItem("kcRetryCount");
				reject(error);
			}
		});
	});
};

const handleLogin = async (idpHint) => {
	try {
		if (keycloak.token) {
			await keycloak.updateToken(30);
			console.log('Token is still valid');
			return;
		}
		console.log('Attempting login with IdP hint:', idpHint);
		await keycloak.login({
			idpHint,
			locale: 'si'
		});
		router.push('/profile');
	} catch (error) {
		console.error('Login failed:', error);
	}
};

const handleRegister = () => {
	console.log('Redirecting to Keycloak registration...');
	keycloak.register({
		redirectUri: window.location.origin
	});
};
/* const handleLogout = () => {
	keycloak.logout({
			redirectUri: '/'
		})
		.then(() => {
			router.push('/');
		})
		.catch((error) => {
			console.error('Logout failed:', error);
		});
}; */

export {
	initKeycloak,
	handleLogin,
	handleRegister,
	//handleLogout,
	keycloak,
};